<template>
    <div class="containter" v-loading = 'loading'>
        <div class="topSelect">
            <div class="item">
                <label>结算单类型：</label>
                <el-select v-model="type" @change="init(1)" style="width:150px" size="mini" clearable placeholder="结算单类型">
                    <el-option
                    v-for="(item,index) in typeList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <label>审核状态：</label>
                <el-select v-model="status" @change="init(1)" style="width:150px" size="mini" clearable placeholder="结算单状态">
                    <el-option
                    v-for="(item,index) in statusList"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <label>消耗表月份：</label>
                <el-date-picker
                    @change="init(1)"
                    style="width:140px;"
                    v-model="screenMonth"
                    :clearable='true'
                    :picker-options="pickerOptionsMonth"
                    type="month"
                    size="mini"
                    value-format="yyyy-MM"
                    placeholder="月份筛选">
                </el-date-picker>
            </div>
            <div class="item">
                <label>申请日期：</label>
                <el-date-picker
                    @change="init(1)"
                    v-model="timeMonth"
                    style="width:240px"
                    type="daterange"
                    size="mini"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </div>
            <div>
                <div class="item">
                    <label>甲方名称：</label>
                    <el-input placeholder="请输入甲方名称" v-model.trim="party_a_name" clearable  @keydown.enter.native="party_a_name?init(1):''" @clear="init(1)" size="mini" style="width:200px;margin-right:20px;">
                        <el-button slot="append" icon="el-icon-search" @click="party_a_name?init(1):''" style="padding:0 10px"></el-button>
                    </el-input>
                </div>
                <div class="item">
                    <label>财务审核时间：</label>
                    <el-date-picker
                        @change="init(1)"
                        style="width:240px"
                        v-model="approved_date"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        size='mini'
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                    </el-date-picker>
                </div>
                <button class="detailButton" @click="statementsTost(2)">MCN结算单</button>
                <button class="detailButton" @click="statementsTost(4)">CPA结算单</button>
                <button class="detailButton" @click="statementsTost(5)">游戏/电商结算单</button>
                <button class="detailButton" @click="statementsTost(6)">拼多多结算单</button>
            </div>
        </div>
        
        <div>
            <ux-grid
                ref="plxTable"
                :height="height"
                show-footer-overflow="tooltip"
                show-overflow="tooltip"
                keep-source
                :edit-config="{trigger: 'manual', mode: 'row'}"
                size="mini">
                <ux-table-column
                        v-for="item in columns"
                        v-if="!item.manyOrder"
                        :key="item.id"
                        :resizable="true"
                        :field="item.prop"
                        :title="item.label"
                        :width="item.width"
                        :fixed="item.fixed"
                        show-header-overflow='tooltip'
                        :edit-render="false"
                        align="center">
                    <template v-slot="{ row }">
                        <span v-if="item.prop == 'type'">{{row[item.prop]==2?'MCN结算单':row[item.prop]==4?'CPA结算单':row[item.prop]==5?'游戏/电商结算单':row[item.prop]==6?'拼多多结算单':''}}</span>
                        <div v-else-if="item.prop == 'files'">
                            <p v-for="(it,ind) in row[item.prop]" :key="ind">{{it}}</p>
                        </div>
                        <span v-else>{{row[item.prop]}}</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="状态" align="center" minWidth="100" fixed="right" field="describe">
                    <template v-slot="{ row }">
                        <span v-if="row.verify_status == 1" style="color:#EF7400">待商务审核</span>
                        <span v-if="row.verify_status == 2" style="color:#3265f3">待财务审核</span>
                        <span v-if="row.verify_status == 3" style="color:#d51313;">商务审核驳回</span>
                        <span v-if="row.verify_status == 4" style="color:#00BB5D;">财务审核通过</span>
                        <span v-if="row.verify_status == 5" style="color:#d51313;">财务审核驳回</span>
                    </template>
                </ux-table-column>
                <ux-table-column title="操作" align="center" minWidth="100" fixed="right" field="describe">
                    <template v-slot="{ row }">
                        <span style="color:#ff9b3c;cursor: pointer;margin-right:5px;" @click="delVerifyOrder(row)" v-if="row.verify_status==1||row.verify_status==3||row.verify_status==5">撤销</span>
                        <span style="color:#00BB5D;cursor: pointer;" v-if="row.invoice_status==1" @click="journalEvent(row)">开票 </span>
                        <span style="color:#5B7BFE;cursor: pointer;margin-right:5px;" @click="goDetail(row)">详情</span>
                    </template>
                </ux-table-column>
            </ux-grid>
            <div class="paginationBox">
                <el-pagination
                    small
                    background
                    :current-page="page"
                    :page-size="page_size"
                    @current-change="handleCurrentChange"
                    layout="total, prev, pager, next"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog title="" :visible.sync="editFlag" width="1200px" top="10vh" :close-on-click-modal='false'>
            <add-statements v-if="editFlag" :statement_status='statement_status' :type='add_type' @cancelToast='cancelToast' @emit_refresh="emit_refresh" :statement_id='statement_id'></add-statements>
        </el-dialog>
        <el-dialog title="开票信息填写" :visible.sync="journalFlag" width="60%" top="10vh" :close-on-click-modal='false'>
            <invoice-filling v-if="journalFlag" :dataList='fillingData' @updateList="emit_refresh" @closeToast='journalFlag=false;'></invoice-filling>
        </el-dialog>
    </div>
</template>
<script>
import columnsJson from '../json/statement_list.js'
import addStatements from './add_statements'
import invoiceFilling from '../invoice/InvoiceFilling'
export default {
    components:{
        invoiceFilling,
        addStatements
    },
    data(){
        return{
            pickerOptionsMonth:{
                disabledDate(time) {
                    return time.getTime() > new Date('2021-03-31 00:00:00');
                },
            },
            editFlag:false,
            status:'',
            statusList:[
                {id:'',name:'不限'},
                {id:1,name:'待商务审核'},
                {id:2,name:'待财务审核'},
                {id:3,name:'商务审核驳回'},
                {id:4,name:'财务审核通过'},
                {id:5,name:'财务审核驳回'},
            ],
            screenMonth:'',
            timeMonth:[],
            type:'',
            typeList:[
                {id:'',name:'不限'},
                {id:2,name:'MCN结算单'},
                {id:4,name:'CPA结算单'},
                {id:5,name:'游戏/电商结算单'},
                {id:6,name:'拼多多结算单'},
            ],
            height:400,
            columns:[],
            page:1,
            page_size:100,
            total:0,
            loading:false,
            add_type:'',
            statement_id:'',
            journalFlag:false,
            fillingData:{},
            statement_status:'',
            party_a_name:'',
            approved_date:[]
        }
    },
    created(){
        this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
        this.columns = columnsJson
        this.init(1)
    },
    mounted(){
        this.height = document.documentElement.clientHeight - 243 > 400 ? document.documentElement.clientHeight - 243 : 400
    },
    methods:{
        journalEvent(data){
            this.fillingData = data;
            this.statement_id = data.id;
            this.journalFlag = true
        },
        statementsTost(type){
            this.fillingData = {}
            this.statement_id = ''
            this.add_type = type;
            this.editFlag=true;
            this.statement_status=''
        },
        emit_refresh(){//编辑成功
            this.journalFlag = false;
            this.editFlag = false;
            this.init(this.page)
        },
        cancelToast(){
            this.editFlag = false;
        },
        goDetail(data){
            this.add_type = data.type;
            this.statement_id = data.id;
            this.editFlag=true;
            this.statement_status = data.verify_status
        },
        delVerifyOrder(data){//撤销
            this.$confirm('确定要撤销吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$loading(this.$loadingConfig)
                this.$axios.post(this.URL.BASEURL + this.URL.statementsComplement_delVerify,{id:data.id}).then((res) => {
                    var res=res.data;
                    this.$loading(this.$loadingConfig).close()
                    if(res&& (res.errno == '0'||res.errno == 0)){
                        this.init(this.page)
                    }else {
                        this.$message({
                            message: res.err,
                            type: 'warning'
                        })
                    }
                }).catch(()=>{
                    this.$loading(this.$loadingConfig).close()
                })
            })
        },
        handleCurrentChange(val){
            this.init(val)
        },
        init(page){
           this.loading = true;
           this.page = page
           this.$axios.get(this.URL.BASEURL + this.URL.statementsComplement_index,{
               params:{
                   type: this.type,
                   month:this.screenMonth,
                   status: this.status,
                   page: page,
                   page_size: this.page_size,
                   apply_start_date: this.timeMonth&&this.timeMonth.length>0?this.timeMonth[0]:'',
                   apply_end_date: this.timeMonth&&this.timeMonth.length>0?this.timeMonth[1]:'',
                   is_my:1,
                   party_a_name:this.party_a_name,
                   approved_start_date: this.approved_date&&this.approved_date.length>0?this.approved_date[0]:'',
                   approved_end_date: this.approved_date&&this.approved_date.length>0?this.approved_date[1]:'',
               }
            }).then((res) => {
                var res=res.data;
                this.loading = false;
                if(res&& res.errno == 0){
                    this.datas = res.rst.data
                    this.$refs.plxTable.reloadData(this.datas)

                    this.total = res.rst.pageInfo.total;
                }else {
                    this.$message({
                        message: res.err,
                        type: 'warning'
                    })
                }
            }).catch(()=>{
                this.loading = false
            })
        },
        
    },
}
</script>
<style lang="scss" scoped>
@import './list.scss';
</style>
<style lang="scss">
.topSelect{
    .el-range-editor--mini .el-range-separator{
        width: 20px !important;
    }
}

</style>


// WEBPACK FOOTER //
// src/components/BeforeApril/statements/list_my.vue